<template>
  <CampaignsQueryLogic>
    <div
      slot-scope="{
        campaigns,
        campaignsErrors,
        canLoadMore,
        loadingCampaigns,
        loadMore,
        refetchCampaigns,
        reloadingCampaigns,
        status,
      }"
      class="campaigns"
    >
      <Section class="p-4 sm:p-6 lg:p-10">
        <div class="max-w-4xl mx-auto">
          <div class="flex flex-wrap items-center mb-4 sm:mb-8">
            <div class="w-full text-center md:w-1/2 md:text-left">
              <h1 class="mt-6 mb-4 text-xl md:text-2xl md:mt-0 md:mb-0">
                Newsletter Campaigns
              </h1>
            </div>
            <div
              class="flex items-center justify-center w-full mb-4 text-center md:w-1/2 md:text-right md:mb-0"
            >
              <Button class="alt md:ml-auto" to="/templates">
                <v-icon
                  slot="icon-start"
                  name="palette"
                  scale=".8"
                  class="inline-block mr-1"
                />
                Browse Templates
              </Button>
            </div>
          </div>

          <!-- Upgrade Failed Banner -->
          <Banner
            v-if="upgradeFailed"
            icon="exclamation-circle"
            type="error"
            title="Upgrade Failed"
            message="Sorry but it looks like we couldn't complete the charge and upgrade your account. If you continue to have the problem, please contact our team so we can investigate."
            class="campaigns-banner"
          />

          <!-- Upgrade Route Fail Banner -->
          <!-- Show this if somebody hit the upgrade route without the correct props -->
          <Banner
            v-if="upgradeRouteFail"
            icon="exclamation-circle"
            type="error"
            title="Error"
            message="Sorry but it looks like you tried to access a page our server wasn't happy with 🤔- If you continue to have the problem, please contact our team so we can investigate."
            class="campaigns-banner"
          />

          <!-- Downgrade Banner -->
          <Banner
            v-if="accountDowngraded"
            icon="check"
            type="success"
            title="Success"
            message="Your account has been downgraded."
            class="campaigns-banner"
          />

          <CampaignList
            class="p-4 mb-6 bg-white rounded-lg sm:p-6 lg:p-10 md:mb-10"
            :reloading="reloadingCampaigns"
            :loading-campaigns="loadingCampaigns"
            :campaigns="campaigns"
            :errors="campaignsErrors"
            :refetch-campaigns="refetchCampaigns"
            :can-load-more="canLoadMore"
            :load-more="loadMore"
            :status="status"
          />
        </div>

        <div class="mt-2 mb-4 divider md:mt-4 lg:mt-6" />
      </Section>
    </div>
  </CampaignsQueryLogic>
</template>

<script>
import Section from "@/components/UI/Section";
import CampaignList from "@/components/Campaigns/CampaignList/CampaignList.vue";
import CampaignsQueryLogic from "@/components/Campaigns/CampaignsQueryLogic.vue";
import Button from "@/components/UI/Button.vue";
import { getAccountId } from "@/lib/auth";
import Banner from "@/components/UI/Banner/Banner";

export default {
  name: "Campaigns",
  components: {
    Banner,
    CampaignList,
    CampaignsQueryLogic,
    Section,
  },
  data() {
    return {
      errors: [],
      accountDowngraded: false,
      upgradeFailed:
        this.$has(this.$route, "query.upgradeSuccessful") &&
        this.$route.query.upgradeSuccessful === "false",
      upgradeRouteFail: this.$has(this.$route, "query.upgradeRouteFail"),
    };
  },
  metaInfo: {
    title: "Campaigns",
  },
  mounted() {
    this.downgradeCheck();
    this.downloadUrlCheck();
    this.campaignSentCheck();
  },
  methods: {
    campaignSentCheck() {
      if (this.$has(this.$route, "query.campaignSent")) {
        this.$modal.show("campaign-sent");
      }
    },
    downgradeCheck() {
      if (
        this.$has(this.$route, "query.downgradeToFree") &&
        this.$route.query.downgradeToFree
      ) {
        this.accountDowngraded = true;

        this.$gtm.trackEvent({
          event: "promo-downgrade",
          accountId: getAccountId(),
        });
      }
    },
    downloadUrlCheck() {
      if (this.$has(this.$route, "params.downloadUrl"))
        window.document.location.href = this.$route.params.downloadUrl;
    },
  },
};
</script>

<style scoped>
.campaigns {
  @apply bg-grey-lightest;
}

.campaigns-banner {
  @apply mx-auto mb-4;

  @screen md {
    @apply mb-8;
  }
}
</style>
